module.exports = __webpack_public_path__ + "img/amaro-smooth.8d061901.jpg";